
import React from "react";
import { CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";

interface ProfileSectionHeaderProps {
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  isSaving: boolean;
}

export const ProfileSectionHeader: React.FC<ProfileSectionHeaderProps> = ({
  isEditing,
  setIsEditing,
  isSaving
}) => {
  return (
    <div className="flex flex-row items-center justify-between pb-2">
      <CardTitle>Profil</CardTitle>
      <Button 
        variant="outline" 
        size="sm" 
        onClick={() => setIsEditing(!isEditing)}
        className="flex items-center gap-1"
        disabled={isSaving}
      >
        <Pencil className="h-4 w-4" />
        {isEditing ? "Annuler" : "Modifier"}
      </Button>
    </div>
  );
};
